import { compose, withProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTSearchTrailerTires from './BOTSearchTrailerTires'

const withInfo = withProps(({ rightContent }) => {
  const { queryParams } = rightContent[0]

  return {
    queryParams
  }
})

export default compose(
  withType({ type: 'BOTSearchTrailerTires', placeholders: ['leftContent', 'rightContent']}),
  withInfo
)(BOTSearchTrailerTires)
